import { render, staticRenderFns } from "./NotImplementedEditor.vue?vue&type=template&id=0806918b&"
import script from "./NotImplementedEditor.vue?vue&type=script&lang=js&"
export * from "./NotImplementedEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports